import { useCallback } from 'react';
import analytics, { AnalyticEvent, Categories, EventType } from '../../helpers/analytics';

export type PushEventData = Pick<AnalyticEvent, 'eventAction'> & Partial<AnalyticEvent>;
export type PushEvent = (data: PushEventData) => void;

export { EventType, Categories };

type GlobalEvent = Required<Pick<AnalyticEvent, 'event' | 'eventCategory' | 'eventLabel'>> & Partial<AnalyticEvent>;

const globalEvent: GlobalEvent = {
    event: EventType.adEvent,
    eventCategory: Categories.Loan,
    eventLabel: '',
};

export const useAnalytics = () => {
    /** Можно указать данные по умолчанию для определенных страниц, используя setGlobalEvent  */
    const pushEvent: PushEvent = useCallback((data) => {
        analytics.emit({
            ...globalEvent,
            ...data,
        });
    }, []);

    /** Задает данные AnalyticEvent глобально, для pushEvent (например, eventCategory)  */
    const setGlobalEvent = useCallback((data: Partial<AnalyticEvent>) => {
        Object.assign(globalEvent, data);
    }, []);

    return { pushEvent, setGlobalEvent, globalEvent };
};
